// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_font-awesome.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import searchpage from './routes/searchpage';
import templateSchoolNurses from './routes/templateSchoolNurses';
import templateServiceOverview from './routes/templateServiceOverview';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Search page
    searchpage,
    // Template School Nurses
    templateSchoolNurses,
    // Template Service Overview
    templateServiceOverview,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js